<template>
    <div class="calculate">

        <div class="calculate-form">
            <div class="row">
                <div class="col-md-6">
                    <label for="calculator-price" class="calculate-form-price">{{ translations[lang].car_price }}</label>
                    <input type="text" id="calculator-price" v-model="form.price" name="price" class="calculate-price-input"
                           placeholder="$">
                    <br>
                    <div class="row">
                        <span class="calculate-auction">{{ translations[lang].auction }}</span>
                        <div class="col-md-4 m-bottom">
                            <input @change="changeType('iaai')" type="radio" class="btn-check" v-model="form.auction" value="iaai"
                                   id="success-outlined" autocomplete="off">
                            <label style="width: 100%;" class="btn btn-outline-danger h-44 " for="success-outlined">
                                <img width="40" :src="'/images/logo.svg'" alt="IAAI">
                            </label>
                        </div>
                        <div class="col-md-4 copart m-bottom">

                            <input @change="changeType('copart')" type="radio" class="btn-check" v-model="form.auction" value="copart"
                                   id="copart-auction" aria-label="Copart" autocomplete="off">
                            <label style="width: 100%" class="btn btn-outline-danger h-44 " for="copart-auction">
                                <img width="55" :src="'/images/coopart.png'" alt="Copart">
                            </label>
                        </div>

                        <div class="col-md-4">
                            <input type="number"
                                   @input="changeType('etc')"
                                   class="calculate-price-input h-44 "
                                   v-model="form.auction_fee"
                                   id="custom-auction-fee" :aria-label="translations[lang].auction_fee" autocomplete="off">
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="sel1" class="calculate-auction">{{ translations[lang].auction_location }}</label>
                        <Select2
                            @change="onPriceListChange"
                            style="padding: 0;"
                            class="form-select calculate-auction-option " id="sel1"
                            v-model="form.auction_location_id" :options="locations"
                        />
                    </div>

                    <div class="form-group">
                        <label for="calculator-shipping" class="calculate-transit">{{ translations[lang].shipping_fee }}</label>
                        <input type="text" id="calculator-shipping" name="shipping" v-model="form.auction_location"
                               class="calculate-price-input" placeholder="$">
                    </div>
                </div>
                <div class="col-md-6 calculate-form__details-column">
                    <div class="form-group">
                        <label for="sel3" class="calculate-car-type">{{ translations[lang].engine_type }}</label>
                        <Select2
                            @change="onMotorTypeChange"
                            style="padding: 0;"
                            class="form-select calculate-auction-option " id="sel3"
                            v-model="form.motor" :options="motor"
                        />

                        <div class="row">
                            <div class="col-md-6">
                                <label for="sel4" class="calculate-age">{{ translations[lang].age }}</label>
                                <Select2
                                    @change="generateYearsList"
                                    style="padding: 0;"
                                    class="form-select calculate-auction-option " id="sel4"
                                    v-model="form.year" :options="years2"
                                />
                            </div>
                            <div class="col-md-6">
                                <label for="sel7" class="calculate-age">{{ translations[lang].production_year }}</label>
                                <Select2
                                    style="padding: 0;"
                                    class="form-select calculate-auction-option " id="sel7"
                                    v-model="form.year2" :options="years"
                                />
                            </div>
                        </div>
                        <label for="calculator-engine-volume" class="calculate-volume">{{ translations[lang].engine_capacity }}</label>
                        <input v-model="form.engine_volume" :disabled="form.motor == 4 && form.auto_type == 'motorcycle'" type="text" id="calculator-engine-volume" name="engine_volume"
                               class="calculate-volume-input" placeholder="0">
                        <label for="sel5" class="calculate-engine">{{ translations[lang].transport_type }}</label>
                        <Select2
                            @change="onAutoTypeChange"
                            style="padding: 0;"
                            class="form-select calculate-auction-option " id="sel5"
                            v-model="form.auto_type" :options="motor_types"
                        />
                        <div class="form-check" v-if="(form.auto_type == 'suv') || (form.auto_type == 'big_suv')">
                            <input class="form-check-input" type="checkbox"
                                   v-model="form.checkbox" id="calculator-high-clearance" >
                            <label class="form-check-label" for="calculator-high-clearance">
                                {{ translations[lang].high_permeability }}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="calculate-submit-button">
                        <button @click="calculate(true)" type="submit" class="btn btn-outline-danger ">
                            <span v-if="success" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                            <span v-if="success" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                            <span v-if="success" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                            <span v-if="!success">{{ translations[lang].calculate }}</span>
                        </button>
                    </div>
                    <p v-if="errorMessage" class="calculator-error" role="alert">{{ errorMessage }}</p>
                </div>
            </div>
        </div>
        <div ref="calculationResults" class="calculate-show" v-if="info.status">
            <div class="row">
                <div class="col-md-6">
                    <p class="last-application-title">{{ translations[lang].final_bid }}</p>
                </div>
                <div class="col-md-6">
                    <p class="last-application-price">${{ info.price}}</p>
                </div>
                <div class="last-application-border"></div>
                <div class="col-md-6">
                    <p class="last-application-title">{{ translations[lang].auction_fee }}</p>
                </div>
                <div class="col-md-6">
                    <p class="last-application-price">${{ info.copart_price}}</p>
                </div>
                <div class="last-application-border"></div>
                <div class="col-md-6">
                    <p class="last-application-title">{{ translations[lang].service_charge }}</p>
                </div>
                <div class="col-md-6">
                    <p class="last-application-price">${{ info.servicePrice}}</p>
                </div>
                <div class="last-application-border"></div>
                <div class="col-md-6">
                    <p class="last-application-title">{{ translations[lang].shipping }}
<!--                        (New Jersey - Փոթի)-->
                    </p>
                </div>
                <div class="col-md-6">
                    <p class="last-application-price">${{ info.auction_location_price}}</p>
                </div>
                <div class="last-application-border"></div>
                <div class="col-md-6">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" @change="handleCheckboxChange"
                               v-model="form.insurance" id="calculator-insurance" >
                        <label class="form-check-label" for="calculator-insurance">
                            {{ translations[lang].insurance }}
                        </label>
                    </div>
                </div>
                <div class="col-md-6">
                    <p :class="['last-application-price', form.insurance  ? '' : 'remove-text' ]">${{ info.insurance_price }}</p>
                </div>

<!--                <div class="col-md-6">-->
<!--                    <div class="form-check">-->
<!--                        <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked1" checked>-->
<!--                        <label class="form-check-label" for="flexCheckChecked1">-->
<!--                            Բարձր անցունակությամբ-->
<!--                        </label>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="col-md-6"></div>-->
                <div class="last-application-border"></div>
                <div class="calculate-total-price">
                    <div class="row">
                        <div class="col-md-6">
                            <h3 class="total-price-title">{{ translations[lang].total_excluding_customs }}</h3>
                        </div>
                        <div class="col-md-6">
                            <p :class="['total-price-number']">
                                ${{ ((info.total + info.servicePrice)).toFixed()}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="margin-left: -20px;margin-right: -20px;" v-if="info.status">
            <div class="col-md-12 calculator-customs-heading">
                <h2>{{ translations[lang].customs_charges }}</h2>
            </div>
            <div class="col-md-6">
                <div :class="['calculate-legal', (info.total_price2 < info.total_price_fiz ) ? 'min-price' : '']" >
                    <h3>{{ translations[lang].legal_person }}</h3>
                    <div class="legal-flex">
                        <p class="legal-flex-title">{{ translations[lang].customs_duty }}</p>
                        <p class="legal-flex-price">${{ info.customs_clearance}}</p>
                    </div>
                    <div class="legal-flex">
                        <p class="legal-flex-title">
                            <span v-if="info.vat == 0" style="text-decoration: line-through;}">{{ translations[lang].vat }}</span>
                            <span v-else >{{ translations[lang].vat }}</span>
                        </p>
                        <p class="legal-flex-price">
                            <span v-if="info.vat == 0" style="text-decoration: line-through;}">${{ info.vat }}</span>
                            <span v-else >${{ info.vat }}</span>
                        </p>
                    </div>
                    <div class="legal-flex">
                        <p class="legal-flex-title">{{ translations[lang].ecological_tax }}</p>
                        <p class="legal-flex-price">${{ info.environmental}}</p>
                    </div>
                    <div class="legal-flex">
                        <p class="legal-flex-title">{{ translations[lang].taxes }}</p>
                        <p class="legal-flex-price">${{ info.tax}}</p>
                    </div>
                    <div class="legal-total-title">
                        <p>{{ translations[lang].total_price }}</p>
                    </div>
                    <div class="legal-total-price">
                        <p>${{ info.total_price2 }}</p>
                    </div>
                    <div>
                        <a
                            :href="`/form-store/${lang}?type=calculatorNew&entity=legal`"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="btn btn-outline-danger download-btn"
                        >
                            <svg class="me-2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.66797 9.99985L10.0013 13.3332M10.0013 13.3332L13.3346 9.99985M10.0013 13.3332V5.66652C10.0013 4.50759 10.0013 3.92813 9.54254 3.27934C9.23772 2.84828 8.36012 2.31625 7.83695 2.24536C7.04954 2.13868 6.75053 2.29467 6.15249 2.60663C3.48741 3.99688 1.66797 6.78588 1.66797 9.99985C1.66797 14.6022 5.39893 18.3332 10.0013 18.3332C14.6037 18.3332 18.3346 14.6022 18.3346 9.99985C18.3346 6.91534 16.6588 4.22224 14.168 2.78137" stroke="#101828" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span>{{ translations[lang].download }}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div :class="['calculate-legal', (info.individual_total_value < info.legal_total_value) ? 'min-price' : '']">
                    <h3>{{ translations[lang].physical_person }}</h3>
                    <div :class="[info.auto_type == 'pickup' || info.auto_type == 'motorcycle' || info.motor == 4 ? 'calculate-legal-margin-44' : 'calculate-legal-margin']">
                        <div v-if="info.auto_type == 'pickup' || info.auto_type == 'motorcycle' || info.motor == 4" class="legal-flex">
                            <p class="legal-flex-title">{{ translations[lang].customs_duty }}</p>
                            <p class="legal-flex-price">${{ info.customs_clearance2}}</p>
                        </div>
                        <div v-if="info.auto_type == 'pickup' || info.auto_type == 'motorcycle' || info.motor == 4" class="legal-flex">
                            <p class="legal-flex-title">
                                <span v-if="info.vat2 == 0" style="text-decoration: line-through;">{{ translations[lang].vat }}</span>
                                <span v-else>{{ translations[lang].vat }}</span>

                                <span v-if="info.electric_exemption_applied" class="tooltip" style="color: red; display: contents">
                                    <i>*</i>
                                    <span class="tooltip-text">
                                        {{ translations[lang].text1 }}
                                        <br>
                                    </span>
                                </span>
                            </p>
                            <p class="legal-flex-price">
                                <span v-if="info.vat2 == 0" style="text-decoration: line-through;">${{ info.vat2 }}</span>
                                <span v-else>${{ info.vat2 }}</span>
                            </p>
                        </div>

                        <div class="legal-flex" v-if="checkMax()">
                            <p class="legal-flex-title">{{ translations[lang].flat_rate }}</p>
                            <p class="legal-flex-price">$ {{ info.customs_clearance2 }}</p>
                        </div>
                        <div class="legal-flex"  >
                            <p class="legal-flex-title">{{ translations[lang].ecological_tax }}</p>
                            <p class="legal-flex-price">${{ info.environmental2}}</p>
                        </div>
                    </div>
                    <div class="legal-total-title">
                        <p>{{ translations[lang].total_price }}</p>
                    </div>
                    <div class="legal-total-price">
                        <p>${{ info.total_price_fiz }}</p>
                    </div>
                    <div>
                        <a
                            :href="`/form-store/${lang}?type=calculatorNew&entity=individual`"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="btn btn-outline-danger download-btn"
                        >
                            <svg class="me-2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.66797 9.99985L10.0013 13.3332M10.0013 13.3332L13.3346 9.99985M10.0013 13.3332V5.66652C10.0013 4.50759 10.0013 3.92813 9.54254 3.27934C9.23772 2.84828 8.36012 2.31625 7.83695 2.24536C7.04954 2.13868 6.75053 2.29467 6.15249 2.60663C3.48741 3.99688 1.66797 6.78588 1.66797 9.99985C1.66797 14.6022 5.39893 18.3332 10.0013 18.3332C14.6037 18.3332 18.3346 14.6022 18.3346 9.99985C18.3346 6.91534 16.6588 4.22224 14.168 2.78137" stroke="#101828" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span>{{ translations[lang].download }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import Select2 from './ui/ModernSelect.vue';

export default {
    name: 'CalculatorComponent',
    components: {Select2},
    props: ['price_shippings', 'session_data', 'motor', 'motor_types', 'yars', 'yars2', 'motor_session', 'validateion', 'lang'],
    data() {
        return {
            info: [],
            success: false,
            errorMessage: '',
            locations: [],
            years: [],
            years2: [],
            locationsValue: [],
            form: {
                price: '',
                auction_location_id: '',
                auction: 'iaai',
                motor: 1,
                auto_type: 'sedan',
                year: 1,
                year2: '',
                auction_fee: '',
                engine_volume: '',
                insurance: true,
            },
            formData: new FormData(),
            translations: {
                am: {
                    car_price: 'Մեքենայի արժեք',
                    auction: 'Աճուրդ',
                    auction_location: 'Աճուրդի վայր',
                    shipping_fee: 'Տեղափոխման վճար',
                    engine_type: 'Շարժիչի տեսակ',
                    age: 'Տարիք',
                    production_year: 'Արտադրության տարի',
                    engine_capacity: 'Շարժիչի ծավալ, սմ³',
                    transport_type: 'Տրանսպորտի տեսակ',
                    high_permeability: 'Բարձր անցողականություն',
                    calculate: 'Հաշվել',
                    calculation_failed: 'Չհաջողվեց կատարել հաշվարկը։ Ստուգեք դաշտերը և կրկին փորձեք։',
                    final_bid: 'Վերջնական հայտը աճուրդում',
                    auction_fee: 'Աճուրդի միջնորդավճար',
                    service_charge: 'Ծառայության վճար',
                    shipping: 'Տեղափոխում (ՀՀ, ք.Գյումրի)',
                    insurance: 'Ապահովագրություն',
                    total_excluding_customs: 'Ընդհանուր գին՝ առանց մաքսազերծման',
                    customs_charges: 'Մաքսային վճարներ',
                    legal_person: 'Իրավաբանական անձ',
                    customs_duty: 'Մաքսատուրք',
                    vat: 'ԱԱՀ',
                    ecological_tax: 'Բնապահպանական հարկ',
                    taxes: 'Բրոքերական ձևակերպումներ',
                    total_price: 'Ընդհանուր գին',
                    physical_person: 'Ֆիզիկական անձ',
                    flat_rate: 'Միասնական դրույքաչափ',
                    download: 'Ներբեռնել',
                    text1: '2026 թ. փետրվարի 1-ից դեկտեմբերի 31-ը՝ 2023 թ. դեկտեմբերի 31-ից հետո արտադրված էլեկտրական մեքենաների համար։ 0% մաքսատուրքը կիրառվում է հաստատված քվոտայի շրջանակում․ վերջնական իրավասությունը հաստատում է մաքսային մարմինը։'
                },
                ru: {
                    car_price: 'Стоимость автомобиля',
                    auction: 'Аукцион',
                    auction_location: 'Штат/Город аукциона',
                    shipping_fee: 'Доставка',
                    engine_type: 'Тип двигателя',
                    age: 'Возраст',
                    production_year: 'Год производства',
                    engine_capacity: 'Объем двигателя см³',
                    transport_type: 'Вид транспорта',
                    high_permeability: 'Высокая проходимость',
                    calculate: 'Рассчитать',
                    calculation_failed: 'Не удалось выполнить расчёт. Проверьте поля и попробуйте ещё раз.',
                    final_bid: 'Окончательная ставка на аукционе',
                    auction_fee: 'Аукционный сбор',
                    service_charge: 'Стоимость услуги',
                    shipping: 'Доставка (Армения, г. Гюмри)',
                    insurance: 'Страховка',
                    total_excluding_customs: 'Общая стоимость без учета растаможки',
                    customs_charges: 'Таможенные платежи',
                    legal_person: 'Юридическое лицо',
                    customs_duty: 'Таможенная пошлина',
                    vat: 'НДС',
                    ecological_tax: 'Экологический налог',
                    taxes: 'Брокерские оформления',
                    total_price: 'Общая цена',
                    physical_person: 'Физическое лицо',
                    flat_rate: 'Единая ставка',
                    download: 'Скачать',
                    text1: 'С 1 февраля по 31 декабря 2026 года — для электромобилей, произведённых после 31 декабря 2023 года. Нулевая таможенная пошлина действует в пределах утверждённой квоты; окончательное право подтверждает таможенный орган.',
                },
                en: {
                    car_price: 'Car Price',
                    auction: 'Auction',
                    auction_location: 'Select Location',
                    shipping_fee: 'Shipping',
                    engine_type: 'Engine type',
                    age: 'Age',
                    production_year: 'Production year',
                    engine_capacity: 'Engine, sm³',
                    transport_type: 'Transport type',
                    high_permeability: 'High permeability',
                    calculate: 'Calculate',
                    calculation_failed: 'The calculation could not be completed. Check the fields and try again.',
                    final_bid: 'Final bid at auction',
                    auction_fee: 'Auction fee',
                    service_charge: 'Service charge',
                    shipping: 'Shipping (Gyumri, RA)',
                    insurance: 'Insurance',
                    total_excluding_customs: 'Total cost excluding customs clearance',
                    customs_charges: 'Customs charges',
                    legal_person: 'Legal person',
                    customs_duty: 'Customs duty',
                    vat: 'VAT',
                    ecological_tax: 'Ecological tax',
                    taxes: 'Customs brokerage services',
                    total_price: 'Total price',
                    physical_person: 'Physical person',
                    flat_rate: 'Flat rate',
                    download: 'Download',
                    text1: 'From 1 February through 31 December 2026 for electric vehicles manufactured after 31 December 2023. The 0% customs duty is subject to the approved quota; final eligibility must be confirmed by customs.',
                },
            },

        }
    },
    created() {
        this.locations = Object.values(this.price_shippings);
        this.generateYearsList();

        if (this.session_data) {
            this.form.price = this.session_data.price;
            this.form.auction = this.session_data.auction;
            this.form.auction_location_id = this.session_data.auction_location_id;
            this.form.auction_location = this.session_data.auction_location_price;
            this.form.auction_fee = this.session_data.copart_price;
            this.form.motor = this.session_data.motor;
            this.form.auto_type = this.session_data.auto_type;
            this.form.year = this.session_data.year;
            this.generateYearsList();
            this.form.year2 = this.session_data.year2;
            this.form.engine_volume = this.session_data.engine_volume;
            this.form.insurance = Number(String(this.session_data.insurance_price).replaceAll(',', '')) > 0;

            this.onPriceListChange(this.form.auction_location_id);
            this.calculate(false);
        }

        this.years2 = this.yars;
    },
    methods: {
        handleCheckboxChange(event) {
            this.calculate()
        },
        generateYearsList() {
            const currentYear = new Date().getFullYear();
            this.form.year2 = '';
            this.years = [];
            if (this.form.year == 1 || this.form.year == 5) {
                const startYear = (currentYear ) - 3;
                const endYear = (currentYear);
                for (let year = endYear; year >= startYear; year--) {
                    this.years.push(year);
                }

            } else if (this.form.year == 2 || this.form.year == 6) {
                const startYear = currentYear - 5;
                const endYear = currentYear - 3;
                for (let year = endYear; year >= startYear; year--) {
                    this.years.push(year);
                }
            } else if (this.form.year == 3) {
                const startYear = currentYear - 7;
                const endYear = currentYear - 5;
                for (let year = endYear; year >= startYear; year--) {
                    this.years.push(year);
                }
            } else if (this.form.year == 4) {
                const startYear = 1950;
                const endYear = currentYear - 7;
                for (let year = endYear; year >= startYear; year--) {
                    this.years.push(year);
                }
            }
        },
        checkMax() {
            if (this.info.auto_type == 'pickup') {
                return 0
            }
            if (this.info.auto_type == 'motorcycle') {
                return 0
            }
            if (this.info.motor == 4) {
                return 0
            }

            return 1;
        },
        onMotorTypeChange(value) {

            if (this.form.motor == 4 && this.form.auto_type == 'motorcycle') {
                this.form.engine_volume = '';
            }

            this.years2 = this.yars
            this.form.year = '';
        },
        onPriceListChange(value) {
            const filteredData = this.locations.filter(item => item.id == value);

            if (filteredData.length) {
                this.locationsValue = filteredData[0];
                this.form.auction_location = this.locationsValue[this.form.auto_type ? this.form.auto_type : 'sedan'];
            }
        },
        onAutoTypeChange(value) {
            if (this.form.motor == 4 && this.form.auto_type == 'motorcycle') {
                this.form.engine_volume = '';
            }
            this.form.auction_location = this.locationsValue[value];
        },
        calculate(scroll) {
            this.success = true;
            this.errorMessage = '';
            this.formData = new FormData();
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            };

            for (const [key, value] of Object.entries(this.form)) {
                this.formData.append(key, (value == null ? '' : value));
            }

            axios.post('/calculator-store-new', this.formData, config).then((response) => {
                if (response.data.status) {
                    this.info = response.data;
                    this.success = false;
                    this.errorMessage = '';
                    this.form.auction_fee = response.data.copart_price;

                    if (scroll) {
                        this.$nextTick(() => {
                            this.$refs.calculationResults?.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start',
                            });
                        });
                    }
                }
            } ).catch((error) => {
                const validationMessages = Object.values(error.response?.data?.errors ?? {}).flat();
                this.errorMessage = validationMessages[0] ?? this.translations[this.lang].calculation_failed;
                this.info = [];
                this.success = false;
            });
        },
        changeType(type = null) {
            this.form.auction = type;
            if (type != 'etc') {
                this.form.auction_fee = '';
            }
        }
    },
    watch: {

    }
}
</script>

<style>
/* Your component styles */
.calculate-form .dropdown-toggle {
    border: none !important;
}

.calculator-error {
    margin: 14px auto 0;
    color: #b42318;
    font-weight: 600;
    text-align: center;
}

.remove-text {
    text-decoration: line-through;
}
.calculate-form .open-indicator {
    display: none !important;
}

.calculate-form .select2 {
    width: 100% !important;
}

.calculate-form .select2-selection--single {
    background-color: transparent !important;
    border: none !important;
    border-radius: 44px;
    height: 44px;
}

.calculate-form .select2-selection__arrow {
    display: none !important;
}

.calculate-form .select2-container--default .select2-selection--single .select2-selection__rendered {
    color: #444;
    line-height: 42px !important;
    padding-left: 20px !important;
    padding-right: 20px !important;
}

.select2-dropdown {
    background-color: white;
    border: 1px solid #aaa !important;
    border-radius: 4px;
    box-sizing: border-box;
    display: block;
    position: absolute;
    left: -100000px;
    width: 100%;
    z-index: 1051;
}

.btn-outline-danger {
    padding: 0 !important;
    display: flex !important;
    justify-content: center;
    align-items: center;

    --bs-btn-color: #000;
    --bs-btn-border-color: #D0D5DD;;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #dc3545;
    --bs-btn-hover-border-color: #D0D5DD;;
    --bs-btn-focus-shadow-rgb: 220, 53, 69;
    --bs-btn-active-color: #000;
    --bs-btn-active-bg: #dc3545;
    --bs-btn-active-border-color: #D0D5DD;;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #000;
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: #D0D5DD;;
    --bs-gradient: none;
}
.btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active {
    border: 3px solid #eb1921;
    color: var(--bs-btn-active-color);
    background-color: transparent;
    --bs-btn-active-border-color: #eb1921;
    border-color: var(--bs-btn-active-border-color);
}

header.navbar-fixed-top {
    height: 96px;
    z-index: 99999999999999999999999999999999;
    background: white;
}
.h-44 {
    height: 44px;
    max-height: 44px;
}
.select2-container--default .select2-results__option--highlighted[aria-selected] {
    background-color: #eb1921;
    color: white;
}
.download-btn {
    margin-top: 40px;
    height: 44px;
    border: 2px solid #ED1C24;
    color: #ED1C24;
    font-weight: 500;
    border-radius: 24px;
}
.m-bottom {
    /* Default styles for larger screens */
    margin-bottom: 0px;
}
.tooltip {
    position: relative;
    cursor: pointer;
}

.tooltip-text {
    visibility: hidden;
    opacity: 0;
    background-color: #555;
    color: #fff;
    text-align: left;
    padding: 15px;
    border-radius: 5px;
    position: absolute;
    z-index: 1;
    width: 200px;
    transform: translateX(-50%);

    transition: opacity 0.3s;
    white-space: pre-line; /* Allow line breaks */
}

.tooltip:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
}
@media (max-width: 768px) {
    .m-bottom {
        margin-bottom: 10px;
    }
}
.min-price {
    border-color: rgb(237, 28, 36);
    box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.1);
}
</style>
